import React, { useState, useEffect } from "react";
import "../../scss/Dashboard.css";
import Navbar from "../../components/Navbar";
import { useDispatch, useSelector } from "react-redux";

import FoodAndDrinkSubReport from "./FoodAndDrinkSubReport";
import { allDataThunk, allData } from "../../redux/allDataSlice";
import { hasQuestions} from "../../Utils/reportGenerator";

const FoodAndDrinkReport = () => {
  const dispatch = useDispatch();
  const [hasDrinks, setHasDrinks] = useState(false);
  const allDataLoaded = useSelector((state) => state.allData.loaded);
  const allDataChanged = useSelector((state) => state.allData.changed);

  useEffect(() => {
    dispatch(allDataThunk());
  }, []);

  useEffect(()=>{
    if (!allDataLoaded) {
      return;
    }
    setHasDrinks(hasQuestions(allData, ["drink1"]));
  }, [allDataChanged]);

  return (
    <div>
      <Navbar />
      <div class="container mid-title card-b-1">
        <div class="mid-title-left">Food{hasDrinks && " and drink"} reports</div>
        <div class="crl"></div>
        <div class="row">
          <div class="col-sm-12 r-text">
          Welcome to your reporting page. Here you will find a selection of reports that you can view and download into excel to help you work with your suppliers as well as plan and budget for every one of your events.
          </div>
        </div>
      </div>
      <div class="main-container">
        <div class="container bg-w">

          <FoodAndDrinkSubReport />
        </div>
      </div>
    </div>
  );
};

export default FoodAndDrinkReport;
